// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__10fkC","label":"SetPasswdForm_label__3dD-u"};